export default "__VITE_ASSET__Cn3OR$a0__"